import {useCallback} from "react";

export const useReload = () => {
    return useCallback(() => window.location.reload(), []);
};
